import { Document, Page, Text, View, Font } from "@react-pdf/renderer";

// Font Registration (Optional, test without first)
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});

const paginateData = (data, rowsPerPage) => {
  const chunks = [];
  for (let i = 0; i < data.length; i += rowsPerPage) {
    chunks.push(data.slice(i, i + rowsPerPage));
  }
  return chunks;
};

const VivaMOCDoc = ({ viva }) => {
  const rowsPerPage = 30;
  const pages = paginateData(viva, rowsPerPage);

  function formatDate(dateInput) {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          style={{ padding: 30, paddingLeft: 50, fontSize: 9, fontFamily: 'Poppins' }}
        >
          {/* Static Header */}
          <View>
            <Text style={{ fontSize: 9, fontWeight: 600 }}>Suvidya Institute of Technology Pvt. Ltd</Text>
          </View>

          {/* Table Container */}
          <View style={{ width: "100%", border: "2px solid black", marginTop: 10 }}>

            {/* header */}
            <View style={{
              width: "100%",
              flexDirection: "row",
              borderBottom: "1px solid black",
              paddingVertical: 3
            }}>
              <View style={{
                width: "60%",
                flexDirection: "row",
                alignItems: "center",
              }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Training Programme :</Text>
                <Text style={{ fontSize: 9, marginLeft: 10 }}>{pageData[0]?.Course_Name}</Text>
              </View>
              <View style={{
                width: "40%",
                flexDirection: 'row',
                alignItems: "center",
              }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Batch :</Text>
                <Text style={{ fontSize: 9, marginLeft: 5 }}>{pageData[0]?.Batch_code}</Text>
              </View>
            </View>

            <View style={{
              width: "100%",
              flexDirection: 'row',
              borderBottom: "1px solid black",
              paddingVertical: 3
            }}>
              <View style={{
                width: "30%",
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: "center",
              }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Viva :</Text>
              </View>
              <View style={{ width: "70%" }}></View>
            </View>

            {/* Table Header */}
            <View style={{
              width: "100%",
              flexDirection: "row",
              borderBottom: "1px solid black",
              minHeight: "18px",
            }}>
              <View style={{ width: "20%", alignItems: "center", borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Roll No</Text>
              </View>
              <View style={{ width: "40%", alignItems: "center", borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Student Name</Text>
              </View>
              <View style={{ width: "12%", alignItems: "center", borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Viva Date</Text>
              </View>
              <View style={{ width: "12%", alignItems: "center", borderRight: "1px solid black" }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Total Marks</Text>
              </View>
              <View style={{ width: "16%", alignItems: "center" }}>
                <Text style={{ fontSize: 9, fontWeight: 600 }}>Marks Obtained</Text>
              </View>
            </View>

            {/* Table Rows */}
            {pageData.map((item, idx) => (
              <View
                key={idx}
                style={{
                  width: "100%",
                  flexDirection: "row",
                  borderBottom: "1px dotted black",
                  minHeight: "18px",  // Use a fixed minHeight in px (adjust as needed)
                }}
              >

                <View style={{ width: "20%", alignItems: "center", borderRight: "1px solid black" }}>
                  <Text style={{ fontSize: 8.5 }}>{item.Student_Code}</Text>
                </View>
                <View style={{ width: "40%", alignItems: "center", borderRight: "1px solid black" }}>
                  <Text style={{ fontSize: 8.5 }}>{item.Student_Name}</Text>
                </View>
                <View style={{ width: "12%", alignItems: "center", borderRight: "1px solid black" }}>
                  <Text style={{ fontSize: 8.5 }}>{formatDate(item.Take_Dt)}</Text>
                </View>
                <View style={{ width: "12%", alignItems: "center", borderRight: "1px solid black" }}>
                  <Text style={{ fontSize: 8.5 }}>{item.marks}</Text>
                </View>
                <View style={{ width: "16%", alignItems: "center" }}>
                  <Text style={{ fontSize: 8.5 }}>{item.Marks_Given}</Text>
                </View>
              </View>
            ))}
          </View>

          {/* Page Number */}
          <View style={{
            width: "100%",
            marginTop: 5,
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}>
            <Text style={{ fontSize: 8.5 }}>{pageIndex + 1}</Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default VivaMOCDoc;
